import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login/login.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage implements OnInit {
  registerForm: FormGroup;
  passwordsMatch = false;
  passwordType = 'password';
  passwordIcon = 'eye';
  btnClicked = false;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private firestore: AngularFirestore
  ) {}

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      accountType: [
        '',
        [Validators.required, Validators.pattern('^[a-zA-Z]+$')],
      ],
      name: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+$')]],
      surname: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+$')]],
      phone: ['', [Validators.required, Validators.pattern('^0[0-9]{9}$')]],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'
          ),
        ],
      ],
      password: ['', [Validators.required, Validators.minLength(6)]],
      passwordConfirmation: [
        '',
        [Validators.required, Validators.minLength(6)],
      ],
    });
  }

  hideShowPassword() {
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
    this.passwordIcon = this.passwordIcon === 'eye-off' ? 'eye' : 'eye-off';
  }

  passwordChange(e) {
    const value = e.target.value;
    const { password, passwordConfirmation } = this.registerForm.value;
    if (value === password && value === passwordConfirmation) {
      this.passwordsMatch = true;
    } else {
      this.passwordsMatch = false;
    }
  }

  register() {
    this.btnClicked = true;
    const { accountType, name, surname, phone, email, password } =
      this.registerForm.value;
    const registerObj = {
      accountType,
      name,
      surname,
      phone,
      email: email.toLowerCase(),
      password,
    };

    if (accountType === 'User') {
      this.loginService.checkPhone(phone).subscribe((data) => {
        if (data.empty) {
          this.loginService
            .registerUser(registerObj)
            .then(() => {
              this.btnClicked = false;
              this.registerForm.reset();
              this.router.navigate(['/home/login']);
            })
            .catch((error) => {
              this.btnClicked = false;
              alert(error.message);
            });
        } else {
          this.btnClicked = false;
          alert('Phone numbers already in use.');
        }
      });
    }

    if (accountType === 'Driver') {
      this.loginService.checkPhone(phone).subscribe((data) => {
        if (data.empty) {
          this.loginService
            .registerDriver(registerObj)
            .then(() => {
              this.btnClicked = false;
              this.registerForm.reset();
              this.router.navigate(['/home/login']);
            })
            .catch((error) => {
              this.btnClicked = false;
              alert(error.message);
            });
        } else {
          this.btnClicked = false;
          alert('Phone numbers already in use.');
        }
      });
    }

    if (accountType === 'Store') {
      this.loginService.checkPhone(phone).subscribe((data) => {
        if (data.empty) {
          this.loginService
            .registerStore(registerObj)
            .then(() => {
              this.btnClicked = false;
              this.registerForm.reset();
              this.router.navigate(['/home/login']);
            })
            .catch((error) => {
              this.btnClicked = false;
              alert(error.message);
            });
        } else {
          this.btnClicked = false;
          alert('Phone numbers already in use.');
        }
      });
    }
  }

  home() {
    this.router.navigate(['home/landing']);
  }

  about() {
    this.router.navigate(['home/about']);
  }

  track() {
    this.router.navigate(['track-order']);
  }

  cart() {
    this.router.navigate(['home/cart']);
  }

  login() {
    this.router.navigate(['home/login']);
  }
  allshops() {
    this.router.navigate(['all-shops']);
  }
}
